export class BasicResult {
    public IsError: boolean;
    public ErrorMessage: string;
    public ErrorCode: string;
    public ErrorReference?: string;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
